export const hubAudioEffects: Map<string, string> = new Map<string, string>([
  ['adventure_hub_ambiance', 'fx/adventure_hub_ambiance.mp3'],
  ['adventure_hub_birthday', 'fx/adventure_hub_birthday.mp3'],
  ['adventure_hub_coffee_machine', 'fx/adventure_hub_coffee_machine.mp3'],
  ['adventure_hub_ping_pong', 'fx/adventure_hub_ping_pong.mp3'],
  ['adventure_hub_seeds', 'fx/adventure_hub_seeds.mp3'],
  ['adventure_hub_weekend', 'fx/adventure_hub_weekend.mp3'],

  ['world_hub_reception_music', 'fx/world_hub_reception_music.mp3'],
  ['world_hub_gym_weights', 'fx/world_hub_gym_weights.mp3'],
  ['world_hub_gym_treadmill', 'fx/world_hub_gym_treadmill.mp3'],
  ['world_hub_gym_music', 'fx/world_hub_gym_music.mp3'],
  ['world_hub_gym_hometrainer', 'fx/world_hub_gym_hometrainer.mp3'],
  ['world_hub_gym_gasping', 'fx/world_hub_gym_gasping.mp3'],
  ['world_hub_reception_hello', 'fx/world_hub_reception_hello.mp3'],
  ['world_hub_meetingroom_speakerbla', 'fx/world_hub_meetingroom_speakerbla.mp3'],
  ['world_hub_meetingroom_tablebla', 'fx/world_hub_meetingroom_tablebla.mp3'],
  ['world_hub_meetingroom_ventilation', 'fx/world_hub_meetingroom_ventilation.mp3'],
  ['world_hub_meetingroom_water', 'fx/world_hub_meetingroom_water.mp3'],
  ['world_hub_lunchroom_music', 'fx/world_hub_lunchroom_music.mp3'],
  ['world_hub_lunchroom_chat', 'fx/world_hub_lunchroom_chat.mp3'],
  ['world_hub_workingroom_laptop_left', 'fx/world_hub_workingroom_laptop_left.mp3'],
  ['world_hub_workingroom_laptop_mid_left', 'fx/world_hub_workingroom_laptop_mid_left.mp3'],
  ['world_hub_workingroom_laptop_mid_right', 'fx/world_hub_workingroom_laptop_mid_right.mp3'],
  ['world_hub_workingroom_book_left', 'fx/world_hub_workingroom_book_left.mp3'],
  ['world_hub_workingroom_book_right', 'fx/world_hub_workingroom_book_right.mp3'],
  ['world_hub_workingroom_music', 'fx/world_hub_workingroom_music.mp3'],
  ['world_hub_brainstormroom_speaker', 'fx/world_hub_brainstormroom_speaker.mp3'],
  ['world_hub_brainstormroom_audience', 'fx/world_hub_brainstormroom_audience.mp3'],
  ['world_hub_brainstormroom_ventilation', 'fx/world_hub_brainstormroom_ventilation.mp3'],
  ['world_hub_gamingroom_ventilation', 'fx/world_hub_gamingroom_ventilation.mp3'],
  ['world_hub_gamingroom_arcade', 'fx/world_hub_gamingroom_arcade.mp3'],
  ['world_hub_gamingroom_climbing', 'fx/world_hub_gamingroom_climbing.mp3'],
  ['world_hub_gamingroom_tablefootball', 'fx/world_hub_gamingroom_tablefootball.mp3'],
  ['world_hub_gamingroom_racing', 'fx/world_hub_gamingroom_racing.mp3'],
  ['world_hub_gamingroom_pooltable', 'fx/world_hub_gamingroom_pooltable.mp3'],
]);